import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Checkbox, Typography } from "@mui/material";
import { CheckboxStyle } from "../../../../PromoCode/CreateNewPromodeod/View/CreatePromoCode";

interface ImageGenerationSwitchAlertProps {
  show: boolean;
  isAskForShowSwitchImageGenerationAlert: boolean;
  setIsAskForShowSwitchImageGenerationAlert: (ask: boolean) => void;
  handleSwitch: () => void;
  handleClose: () => void;
}

export const ImageGenerationSwitchAlert = ({
  show,
  handleSwitch,
  handleClose,
  isAskForShowSwitchImageGenerationAlert,
  setIsAskForShowSwitchImageGenerationAlert,
}: ImageGenerationSwitchAlertProps) => {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsAskForShowSwitchImageGenerationAlert(event.target.checked);
  };

  return (
    <>
      <Dialog
        open={show}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="promo-dialog"
      >
        <DialogTitle id="promo-alert-title">Image generation</DialogTitle>
        <DialogContent sx={{ padding: "8px 0" }}>
          <DialogContentText id="alert-dialog-description">
            Changing the mode will stop image generation!
            <br />
            Are you sure you want to switch?
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            flexDirection: "column",
            paddingTop: "0 !important",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              alignSelf: "flex-start",
            }}
          >
            <Checkbox
              {...label}
              sx={CheckboxStyle}
              name="usageLimit"
              checked={isAskForShowSwitchImageGenerationAlert}
              onChange={handleCheckboxChange}
            />
            <Typography className="select-option-text">
              Don’t ask me again.
            </Typography>
          </Box>
          <div className="d-flex pb-3 px-4 buttons justify-content-end w-100">
            <button className="cancelDeleteBtn me-2" onClick={handleSwitch}>
              Yes, switch
            </button>
            <button className="confirmDeleteBtn" onClick={handleClose}>
              No, stay here
            </button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};
